import {Injectable} from "@angular/core";
import {ClientUser, MeUser} from "shared/user";
import {ClientSettingsModel} from "shared/client.settings";

@Injectable({
    providedIn: 'root'
})
/* Отдельный сервис необходим, чтоб избежать циклических зависимостей*/
export class UserInfoService {
    private _session: string
    private _me: MeUser
    private _settings: ClientSettingsModel

    setData(user: MeUser, settings: ClientSettingsModel, session: string) {
        this._session = session
        this._me = user
        this._settings = settings
    }

    clearData() {
        this._me = null
        this._settings = null
        this._session = null
    }

    get session(): string {
        return this._session;
    }

    get settings(): ClientSettingsModel {
        return this._settings;
    }

    get me(): MeUser {
        return this._me;
    }

    updateUser(user: MeUser) {
        this._me = user
    }

}